import React, { useEffect, useState, Fragment, useRef } from "react";
import { TableContent } from '../../../Common/Table/tableContent';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const data = this.props.data;

        const employeeCount = this.props.employeeCount
        const totCheRollNetAmountVariance = this.props.totCheRollNetAmountVariance
        const totalFeildBagCount = this.props.totalFeildBagCount
        const totFeildNetAmountVariance = this.props.totFeildNetAmountVariance
        const totalFactoryBagCount = this.props.totalFactoryBagCount
        const totFactoryNetAmountVariance = this.props.totFactoryNetAmountVariance
        const totCheckrollFactorynetVariance = this.props.totCheckrollFactorynetVariance
        const totCheckrollFactoryVariancePecentage = this.props.totCheckrollFactoryVariancePecentage
        const totfeildFactorynetVariance = this.props.totfeildFactorynetVariance
        const totFeildtoFactoryVariancePecentage = this.props.totFeildtoFactoryVariancePecentage

        return (
            <div>
                <h3><center><u>Crop Variance Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>State: </b> {searchData.estate}</div>
                    <div className="col"><b>Devision: </b> {searchData.division}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                </div>


                <div>
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell rowSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                        Feild
                                    </TableCell>
                                    <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                        CheckRoll
                                    </TableCell>
                                    <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                        Feild
                                    </TableCell>
                                    <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                        Factory
                                    </TableCell>
                                    <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                        C to F variance
                                    </TableCell>
                                    <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                        F to F variance
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                        Weighment
                                    </TableCell>

                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                        Net
                                    </TableCell>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                        Bags
                                    </TableCell>

                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                        Net
                                    </TableCell>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                        Bags
                                    </TableCell>

                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                        Net
                                    </TableCell>

                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                        Net
                                    </TableCell>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                        Net%
                                    </TableCell>

                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                        Net
                                    </TableCell>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                        Net%
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.map((row) => (
                                    <TableRow key={row.divisionID}>
                                        <TableCell component="th" align="center" >
                                            {row.fieldName}
                                        </TableCell>
                                        <TableCell component="th" align="center" >
                                            {row.noOfWorkers == undefined ? '-' : parseInt(row.noOfWorkers)}
                                        </TableCell>

                                        <TableCell align="center">
                                            {row.netAmount == undefined || row.netAmount == 0 ? '-' : row.netAmount.toFixed(2)}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row.fBagCount == undefined ? '-' : parseInt(row.fBagCount)}
                                        </TableCell>

                                        <TableCell align="center">
                                            {row.fNetAmount == undefined || row.fNetAmount == 0 ? '-' : row.fNetAmount.toFixed(2)}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row.nBagCount == undefined ? '-' : parseInt(row.nBagCount)}
                                        </TableCell>

                                        <TableCell align="center">
                                            {row.nNetAmount == undefined || row.nNetAmount == 0 ? '-' : row.nNetAmount.toFixed(2)}
                                        </TableCell>

                                        <TableCell align="center" >
                                            <span className={row.fNetAmountVariance > 0 ? "badge badge-primary" : "badge badge-danger"}>
                                                {parseFloat(row.fNetAmountVariance).toFixed(2)}
                                            </span>
                                        </TableCell>
                                        <TableCell align="center" >
                                            <span className={row.cfNetAmountVariancePecentage > 0 ? "badge badge-primary" : "badge badge-danger"}>
                                                {row.cfNetAmountVariancePecentage == '-' ? '-' : parseFloat(row.cfNetAmountVariancePecentage).toFixed(2)}
                                            </span>
                                        </TableCell>
                                        <TableCell align="center" >
                                            <span className={row.ffNetAmountVariance > 0 ? "badge badge-primary" : "badge badge-danger"}>
                                                {parseFloat(row.ffNetAmountVariance).toFixed(2)}
                                            </span>
                                        </TableCell>
                                        <TableCell align="center" >
                                            <span className={row.fNetAmountVariancePecentage > 0 ? "badge badge-primary" : "badge badge-danger"}>
                                                {row.fNetAmountVariancePecentage == '-' ? '-' : parseFloat(row.fNetAmountVariancePecentage).toFixed(2)}
                                            </span>
                                        </TableCell>

                                    </TableRow>
                                ))}
                            </TableBody>
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Total</TableCell>
                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold" }}>{"Pluckers" + " " + "-" + " " + employeeCount[0].employee}</TableCell>
                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold" }}>{totCheRollNetAmountVariance}</TableCell>
                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold" }}> {totalFeildBagCount}</TableCell>
                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold" }}> {parseFloat(totFeildNetAmountVariance).toFixed(2)}</TableCell>
                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold" }}> {totalFactoryBagCount}</TableCell>
                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold" }}> {parseFloat(totFactoryNetAmountVariance).toFixed(2)}</TableCell>
                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold" }}> {parseFloat(totCheckrollFactorynetVariance).toFixed(2)}</TableCell>
                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold" }}> {totCheckrollFactoryVariancePecentage}</TableCell>
                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold" }}> {parseFloat(totfeildFactorynetVariance).toFixed(2)}</TableCell>
                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold" }}> {totFeildtoFactoryVariancePecentage}</TableCell>
                                </TableRow>

                            </TableHead>

                        </Table>
                    </TableContainer>
                </div>
            </div>
        );
    }
}


